import { React, useState } from "react";
import axios from "axios";
import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import { Icon } from "leaflet";
import "leaflet/dist/leaflet.css";

function Contact_form() {
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [text, setText] = useState("");
  const [response, setResponse] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  let errors = [];
  let handleSubmitContact = async (e) => {
    e.preventDefault();
    document.querySelector(".errors_contacts").innerHTML = "";

    //Validate
    if (email == "" || email == null) {
      errors.push({ m: "لطفا ایمیل خود را وارد کنید" });
    }
    if (phone == "" || phone == null) {
      errors.push({ m: "لطفا شماره موبایل خود را وارد کنید" });
    }
    if (text == "" || text == null) {
      errors.push({ m: "لطفا متن پیام خود را بنویسید" });
    }
    if (errors.length > 0) {
      let nodes_contact = errors.map((err) => {
        let p = document.createElement("p");
        p.textContent = err.m;
        return p;
      });
      document.querySelector(".errors_contacts").append(...nodes_contact);
    } else {
      setLoading(true);
      (async () => {
        // POST request using axios with async/await
        const data = {
          email: email,
          phone: phone,
          message: text,
        };
        axios
          .post(
            "https://panel.baghban.restaurant/api/contact-us/send-message",
            data
          )
          .then((response) => {
            setResponse("seccuss");
            setMessage(response.data.msg + ". به زودی با شما تماس خواهیم گرفت");
            setLoading(false);
            //Clear form
            setEmail("");
            setPhone("");
            setText("");
          })
          .catch(function (error) {
            setResponse("failed");
            setMessage("خطایی رخ داده است");
            setLoading(false);
          });
      })();
    }
  };
  const customIcon = new Icon({
    iconUrl: "images/location.png",
    iconSize: [38, 38],
  });

  const openGoogleMaps = () => {
    const lat = 36.30991;
    const lng = 59.361484;
    const url = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
    window.open(url, "_blank");
  };

  return (
    <div className="contact-form">
      <div className="container">
        <div className="row">
          <div className={loading ? "active loading" : "loading"}>
            <img
              src={process.env.PUBLIC_URL + "/images/loading.svg"}
              className="img-fluid"
            />
          </div>
          <div className="col-lg-6 col-12">
            <h2 className="title-form">برای ما پیام ارسال کنید</h2>
            {/* <p className="subtitle-form">
                        لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد
                        </p> */}
            <form className="contact-form__form" onSubmit={handleSubmitContact}>
              <div className="contact-form__form__form-item">
                <label
                  htmlFor="email_contact"
                  className="contact_form__form__label"
                >
                  ایمیل
                </label>
                <input
                  type="email"
                  name="email_contact"
                  id="email_contact"
                  className="contact_form__form__input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="contact-form__form__form-item">
                <label
                  htmlFor="phone_contact"
                  className="contact_form__form__label"
                >
                  شماره تماس
                </label>
                <input
                  type="tel"
                  name="phone_contact"
                  id="phone_contact"
                  className="contact_form__form__input"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>
              <div className="contact-form__form__form-item">
                <label
                  htmlFor="message_contact"
                  className="contact_form__form__label"
                >
                  پیام شما
                </label>
                <textarea
                  name="message_contact"
                  id="message_contact"
                  className="contact_form__form__textarea"
                  rows="6"
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                ></textarea>
              </div>
              <div className="contact-form__form__form-item">
                <button
                  type="submit"
                  name="submit_contact"
                  id="submit_contact"
                  className="contact_form__form__submit"
                >
                  ارسال
                </button>
              </div>
              <div className={response}>
                {message ? <p>{message}</p> : null}
              </div>
              <div className="errors_contacts"></div>
            </form>
          </div>
          <div className="col-lg-6 col-12">
            <div className="contact-map">
              <MapContainer
                center={[36.30991, 59.361484]}
                zoom={15}
                scrollWheelZoom={false}
                style={{ width: "100%", height: "480px", borderRadius: 5 }}
              >
                <TileLayer
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Marker position={[36.30991, 59.361484]} icon={customIcon}>
                  <Popup>
                    <div>
                      رستوران باغبان <br />
                    </div>
                    <button
                      style={{
                        borderRadius: "5px",
                        padding: "5px 10px",
                        marginTop: "5px ",
                        cursor: "pointer",
                        background: "#262626",
                        color: "white",
                        border: "none",
                      }}
                      onClick={openGoogleMaps}
                    >
                      باز کردن در گوگل مپ
                    </button>
                  </Popup>
                </Marker>
              </MapContainer>
              {/* <img
                src="https://api.neshan.org/v2/static?key=service.b04e056d0c2343e184882d10b14b7b6a&type=osm-bright&zoom=16&center=36.309869,59.362162&width=600&height=572&marker=violet"
                className="img-fluid"
              /> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact_form;
